(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gc-card-overrides"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__gcQuickAddReady) return;
    window.__gcQuickAddReady = true;

    function cartUrl() {
      return (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';
    }

    function openDrawer() {
      var drawer = document.querySelector('theme-drawer#cart-drawer');
      if (!drawer || typeof drawer.open !== 'function') {
        window.location.href = cartUrl();
        return;
      }
      if (drawer.hasAttribute('open') || drawer.isOpen) return;
      drawer.open();
    }

    /* Used only when the theme's own handler did not take the submit. */
    function refreshDrawer() {
      var items = document.querySelector('cart-items-component');
      var current = document.querySelector('cart-drawer-component');
      var sectionId = items && items.dataset ? items.dataset.sectionId : null;
      if (!current || !sectionId) return Promise.resolve();

      return fetch(window.location.pathname + '?sections=' + encodeURIComponent(sectionId), {
        credentials: 'same-origin',
      })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          var html = data && data[sectionId];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('cart-drawer-component');
          if (fresh) current.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    }

    function fallbackAdd(form) {
      var addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
      fetch(addUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form),
      })
        .then(function (response) { return response.json(); })
        .then(function (result) {
          if (result && result.status) return;
          return refreshDrawer().then(openDrawer);
        })
        .catch(function () {});
    }

    /* Registered on window so it runs after the theme's document-level handlers. */
    window.addEventListener('submit', function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.closest('.kr-product-card quick-add-component')) return;

      if (event.defaultPrevented) {
        /* The theme handled the add; its drawer normally opens by itself. This is a net. */
        setTimeout(openDrawer, 1500);
        return;
      }

      event.preventDefault();
      fallbackAdd(form);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gc-cart-overrides"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__gcUpsellPagerReady) return;
    window.__gcUpsellPagerReady = true;

    var DURATION = 320;

    /* Scroll offset of every page, from layout (`offsetLeft`), so it is the same whether or not
       the track is mid-animation. */
    function pageStarts(track) {
      var starts = [];
      var first = track.children[0];
      if (!first) return starts;

      var origin = first.offsetLeft;
      var previous = null;

      for (var i = 0; i < track.children.length; i++) {
        var left = track.children[i].offsetLeft - origin;
        if (previous === null || Math.abs(left - previous) > 2) {
          starts.push(left);
          previous = left;
        }
      }

      return starts;
    }

    function nearestPage(track, starts) {
      var index = 0;
      var best = Infinity;

      for (var i = 0; i < starts.length; i++) {
        var distance = Math.abs(starts[i] - track.scrollLeft);
        if (distance < best) {
          best = distance;
          index = i;
        }
      }

      return index;
    }

    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    function animateTo(track, left) {
      if (track.__gcFrame) cancelAnimationFrame(track.__gcFrame);

      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var from = track.scrollLeft;
      var distance = left - from;

      /* Snapping would pull against every frame of the animation. */
      track.style.scrollSnapType = 'none';
      track.__gcAnimating = true;

      function finish() {
        track.scrollLeft = left;
        track.style.scrollSnapType = '';
        track.__gcAnimating = false;
        track.__gcFrame = null;
      }

      if (reduceMotion || Math.abs(distance) < 2) {
        finish();
        return;
      }

      var startTime = null;

      function step(now) {
        if (startTime === null) startTime = now;
        var progress = Math.min((now - startTime) / DURATION, 1);
        track.scrollLeft = from + distance * easeOutCubic(progress);

        if (progress < 1) {
          track.__gcFrame = requestAnimationFrame(step);
        } else {
          finish();
        }
      }

      track.__gcFrame = requestAnimationFrame(step);
    }

    /* Capture phase + stopPropagation: this replaces the listener in blocks/cart-upsell.liquid. */
    document.addEventListener(
      'click',
      function (event) {
        var target = event.target instanceof Element ? event.target : null;
        var arrow = target ? target.closest('[data-cart-upsell-prev], [data-cart-upsell-next]') : null;
        if (!arrow) return;

        event.preventDefault();
        event.stopPropagation();

        var root = arrow.closest('.cart-upsell');
        var track = root ? root.querySelector('[data-cart-upsell-track]') : null;
        if (!track) return;

        var starts = pageStarts(track);
        if (starts.length < 2) return;

        /* Mid-animation the page is the one being scrolled TO, not wherever scrollLeft is. */
        var current = track.__gcAnimating && typeof track.__gcPage === 'number'
          ? track.__gcPage
          : nearestPage(track, starts);

        if (current >= starts.length) current = 0;

        var direction = arrow.hasAttribute('data-cart-upsell-next') ? 1 : -1;
        var next = (current + direction + starts.length) % starts.length;

        track.__gcPage = next;
        animateTo(track, starts[next]);
      },
      true
    );

    /* Keep the index in step with finger swipes. `scroll` does not bubble, hence capture. */
    document.addEventListener(
      'scroll',
      function (event) {
        var track = event.target;
        if (!(track instanceof Element) || !track.hasAttribute('data-cart-upsell-track')) return;
        if (track.__gcAnimating) return;

        clearTimeout(track.__gcSync);
        track.__gcSync = setTimeout(function () {
          track.__gcPage = nearestPage(track, pageStarts(track));
        }, 120);
      },
      { capture: true, passive: true }
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
